export default {
  selectPreset: 'Voreinstellung auswählen',
  resetPreset: 'Änderungen an der Voreinstellung zurücksetzen',
};
